module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    廠商對帳記錄表已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("新後台管理系統 > 財務中心 > 帳務明細")]), _vm._v("\n    」，請至新後台管理系統檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "nav nav-tabs flex",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.typeSelect === 99
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 99
      }
    }
  }, [_vm._v("金流\n              ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.typeSelect === 1
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 1
      }
    }
  }, [_vm._v("物流\n              ")])]), _vm._v(" "), (_vm.getRestricted.indexOf(900) !== -1) ? _c('li', {
    class: {
      active: _vm.typeSelect === 10
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typeSelect = 10
      }
    }
  }, [_vm._v("資訊服務費抽成\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-l-auto flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-default btn-table-title z-100 h-38",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }, [_vm._v("下載報表")]), _vm._v(" "), _c('clip-loader', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)]), _vm._v(" "), _c('div', [(_vm.showHistoryReport) ? _c('button', {
    staticClass: "btn btn-default btn-table-title z-100 h-38 m-l-5",
    attrs: {
      "title": !_vm.brandSelect.value ? '請選擇品牌' : '',
      "disabled": ""
    },
    on: {
      "click": _vm.goCommissionHistory
    }
  }, [_vm._v("\n                  歷史報表\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.typeSelect === 1 && _vm.shippingInfo.mete_portal_url) ? _c('div', [_c('button', {
    staticClass: "btn btn-default btn-table-title z-100 h-38 m-l-5",
    on: {
      "click": _vm.openLink
    }
  }, [_vm._v("\n                  查詢儲值金餘額\n                ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.typeSelect === 99) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.brandBrief.length > 2 || _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "flex m-b-10"
  }, [(_vm.brandBrief.length > 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2) ? _c('div', {
    class: ['inline-block from-group pull-left', {
      'm-l-5': _vm.brandBrief.length > 2
    }],
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountingSelect),
      expression: "accountingSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accountingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.accountingList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                " + _vm._s(type.label) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tradeTypeSelect),
      expression: "tradeTypeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tradeTypeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.traceTypeOption), function(trade) {
    return _c('option', {
      domProps: {
        "value": trade.value
      }
    }, [_vm._v("\n                " + _vm._s(trade.label) + "\n              ")])
  }), 0)]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportSelect),
      expression: "reportSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reportSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("\n                == 報表類型 ==\n              ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("\n                原始報表\n              ")]), _vm._v(" "), (_vm.tradeTypeSelect === 713) ? _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("\n                對外對帳單\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceSelect),
      expression: "sourceSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("\n                == 訂單來源 ==\n              ")]), _vm._v(" "), (_vm.tradeTypeSelect === 908) ? _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("\n                街口APP\n              ")]) : _vm._e(), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("\n                你訂\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "m-l-auto flex",
    staticStyle: {
      "max-width": "340px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group h-38 m-l-5"
  }, [_c('div', {
    staticClass: "input-group h-38"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSN),
      expression: "orderSN"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSN = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單類型")]) : _vm._e(), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單狀態")]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款完成日")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("支付卡別")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("收單行")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折扣")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單總金額")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("付款類型")]) : _vm._e(), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(3)]) : (!_vm.isLoading && _vm.history.length > 0) ? _c('tbody', _vm._l((_vm.history), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                          " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                          " + _vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.order_sn) + "\n                      ")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_vm._v("\n                          " + _vm._s(_vm._f("deliveryName")(row.delivery_type)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_c('label', {
      staticClass: "label",
      class: _vm._f("orderStateColor")(row.order_status)
    }, [_vm._v("\n                            " + _vm._s(_vm._f("orderStatusName")(row.order_status)) + "\n                          ")])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.trade_date) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.trade_finish_date) + "\n                      ")]), _vm._v(" "), _c('td', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.creditCardType(row.card_type))
      }
    })]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(row.acquirer ? row.acquirer : '-') + "\n                      ")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_vm._v("\n                          $" + _vm._s(row.total_money - row.total_paid_money) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                          $" + _vm._s(row.total_paid_money) + "\n                      ")]), _vm._v(" "), (_vm.reportSelect === 1 || _vm.reportSelect === 999) ? _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.tradeTypeColor(_vm.tradeType(row.trade_type))
    }, [_vm._v(_vm._s(_vm.tradeType(row.trade_type)))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm.accountingType(row.accounting_type)
    }, [_vm._v(_vm._s(row.accounting_type === 1 ? '收款' : '退款'))])])])
  }), 0) : (!_vm.isLoading && _vm.history.length === 0) ? _c('tbody', [_vm._m(4)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.paymentPageAmount,
      "total": _vm.pagination.paymentFlow.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.pagination.paymentFlow.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 1) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.brandBrief.length > 2 || _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "flex m-b-10"
  }, [(_vm.brandBrief.length > 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2) ? _c('div', {
    class: ['inline-block from-group pull-left', {
      'm-l-5': _vm.brandBrief.length > 2
    }],
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingVendorSelect),
      expression: "shippingVendorSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippingVendorSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.shippingVendorList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                " + _vm._s(item.label) + "\n              ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceType),
      expression: "sourceType"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.sourceTypeList), function(order) {
    return _c('option', {
      domProps: {
        "value": order.value,
        "textContent": _vm._s(order.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userType),
      expression: "userType"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.userTypeList), function(shopper) {
    return _c('option', {
      domProps: {
        "value": shopper.value,
        "textContent": _vm._s(shopper.label)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatus),
      expression: "orderStatus"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.orderStatusList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-l-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingStatus),
      expression: "shippingStatus"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shippingStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.shippingStatusList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-38 m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "m-l-auto flex",
    staticStyle: {
      "max-width": "340px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.searchType),
      expression: "searchType",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("物流查詢編號")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group h-38 m-l-5"
  }, [_c('div', {
    staticClass: "input-group h-38"
  }, [(_vm.searchType == 2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderSN),
      expression: "orderSN"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderSN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderSN = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType == 3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.venderOrderNo),
      expression: "venderOrderNo"
    }],
    staticClass: "form-control h-38",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.venderOrderNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.venderOrderNo = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])]), _vm._v(" "), (_vm.shippingInfo.overview) ? _c('div', [_c('ul', [_c('li', [_vm._v("訂單總金額：$ " + _vm._s(_vm.shippingInfo.overview.total_money))]), _vm._v(" "), _c('li', [_vm._v("訂單總數：" + _vm._s(_vm.shippingInfo.overview.total_amount))]), _vm._v(" "), _c('li', [_vm._v("物流總費用：$ " + _vm._s(_vm.shippingInfo.overview.total_vendor_fee))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌名稱(ID)")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單來源")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂購人類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流查詢編號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單總金額(元)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("訂單折扣(元)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流費用(元)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流廠商")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("物流狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("距離")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實際取貨時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實際送達時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("預計取貨時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("預計送達時間")])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(5)]) : (!_vm.isLoading && _vm.shippingTableList.length > 0) ? _c('tbody', _vm._l((_vm.shippingTableList), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                  " + _vm._s(index + 1) + "\n                ")]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                  " + _vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.source_type || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.user_type || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.order_sn || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.customer_order_no || '-') + "\n                ")]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm._f("orderStateColor")(row.order_status)
    }, [_vm._v("\n                    " + _vm._s(_vm._f("orderStatusName")(row.order_status)) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.order_date || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_paid_money || 0) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.discount_money || 0) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.vendor_fee) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm._f("shippingVendorName")(row.vendor_code)) + "\n                ")]), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "label",
      class: _vm._f("shippingStateColor")(row.shipping_status)
    }, [_vm._v("\n                    " + _vm._s(_vm._f("shippingStatusName")(row.shipping_status)) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.distance || row.distance === 0 ? Math.round(row.distance / 1000 * 1000) / 1000 + '公里' : '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.actual_get_time || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.actual_arrived_time || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.expected_get_time || '-') + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.expected_arrived_time || '-') + "\n                ")])])
  }), 0) : (!_vm.isLoading && _vm.shippingTableList.length === 0) ? _c('tbody', [_vm._m(6)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.shippingPageAmount,
      "total": _vm.pagination.shippingFlow.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.pagination.shippingFlow.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 10) ? _c('div', [((_vm.getRoleType === 99 && !_vm.storeSelect.value) || _vm.commissionInfo.show_allow_void_commission_detail) ? _c('div', [(_vm.getRoleType === 99 && !_vm.storeSelect.value) ? _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            下列對帳表不含獨立簽約門市的抽成資訊，如需檢視請先切換至該門市。\n          ")]) : _vm._e(), _vm._v(" "), (_vm.commissionInfo.show_allow_void_commission_detail) ? _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n            每月作廢訂單額度於次月 4 日才會納入計算。\n          ")]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.brandBrief.length > 2 || _vm.storeBrief.length > 2) ? _c('div', {
    staticClass: "flex m-b-10"
  }, [(_vm.brandBrief.length > 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2) ? _c('div', {
    class: ['inline-block from-group pull-left', {
      'm-l-5': _vm.brandBrief.length > 2
    }],
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeType),
      expression: "timeType"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.timeTypeList), function(type) {
    return _c('option', {
      key: ("type-" + (type.value)),
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                  " + _vm._s(type.name) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.yearList), function(val) {
    return _c('option', {
      key: ("year" + val),
      domProps: {
        "value": val
      }
    }, [_vm._v("\n                  " + _vm._s(val + '年') + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.timeType === 'monthly') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((12), function(val) {
    return _c('option', {
      key: ("month" + val),
      domProps: {
        "value": val
      }
    }, [_vm._v("\n                  " + _vm._s(val + '月') + "\n                ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.timeType === 'quarterly') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quarter),
      expression: "quarter"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.quarter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.quarterList), function(val) {
    return _c('option', {
      key: ("quarter" + (val.value)),
      domProps: {
        "value": val.value
      }
    }, [_vm._v("\n                  " + _vm._s(val.name) + "\n                ")])
  }), 0) : _vm._e()])])]), _vm._v(" "), (_vm.brandSelect.value) ? _c('ul', {
    staticClass: "m-t-10"
  }, [(_vm.commissionInfo.show_allow_void_commission_detail) ? [_c('li', [_vm._v("\n              資訊服務費抽成原金額(A)： $" + _vm._s(_vm.commissionInfo.original_commission_money) + "\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              可扣除的作廢訂單(B)\n              "), _vm._m(7), _vm._v("\n              ： " + _vm._s(_vm.commissionInfo.allow_void_commission_amount) + "/" + _vm._s(_vm.commissionInfo.allow_invalid_order_quota) + " 筆，共 $" + _vm._s(_vm.commissionInfo.allow_void_commission_money) + "\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              當月資訊服務費抽成金額(A-B)： $" + _vm._s(_vm.commissionInfo.total_commission_money) + "\n            ")])] : [_c('li', [_vm._v("\n              資訊服務費抽成原金額： $" + _vm._s(_vm.commissionInfo.original_commission_money) + "\n            ")])]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(8), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(9)]) : (_vm.commissionList.length) ? _c('tbody', _vm._l((_vm.commissionList), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                  " + _vm._s(index + 1) + "\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                  " + _vm._s(row.brand_name) + "(" + _vm._s(row.brand_id) + ")\n                ")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: ("/commissionStore/" + (row.store_id)),
          query: {
            year: _vm.year,
            type: _vm.timeType,
            period: _vm.timeType === 'quarterly' ? _vm.quarter : _vm.month
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(row.store_name) + "(" + _vm._s(row.store_id) + ")\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_paid_money) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_finish_commission_money) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_void_commission_money) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(row.total_commission_money) + "\n                ")])])
  }), 0) : _c('tbody', [_vm._m(10)])])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.commissionPageAmount,
      "total": _vm.pagination.commission.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.pagination.commission.groupAmount,
      "clickPage": _vm.changePage
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "form-control h-38"
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("訂單編號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易日期\n                        "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "訂單建立日期"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("交易類型\n                        "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "退款為已申請退款非完成退款"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "14"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "16"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "以下訂時間，早下訂的先扣除"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("分店(ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("實付總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已完成訂單資訊服務費抽成總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已作廢訂單資訊服務費抽成總金額")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                  資訊服務費抽成總金額\n                  "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "已完成+已作廢訂單資訊服務費抽成金額"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "7"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d96bec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/VenderTradeTable/index.vue
// module id = 2352
// module chunks = 1